import { environment } from '../../environments/environment';

export class APIRoutes {
  public static readonly BASE_URL = environment.BASE_API_URL;
  public static readonly COUNTRIES_ROUTE = `${APIRoutes.BASE_URL}/countries`;
  public static readonly TIMEZONES_ROUTE = `${APIRoutes.BASE_URL}/timezones`;
  public static readonly ETHNICITIES_ROUTE = `${APIRoutes.BASE_URL}/ethnicities`;
  public static readonly SEXES_ROUTE = `${APIRoutes.BASE_URL}/sexes`;
  public static readonly SIGNUP_ROUTE = `${APIRoutes.BASE_URL}/sign-up`;
  public static readonly ORG_LEVEL_PERMISSIONS_ROUTE = `${APIRoutes.BASE_URL}/org-level-permissions`;
  public static readonly TWO_FA_ROUTE = `${APIRoutes.BASE_URL}/sign-in/request-2fa`;
    public static readonly CHECK_TWO_FA_ROUTE = `${APIRoutes.BASE_URL}/sign-in/check-2fa`;


  public static readonly USERS_ROUTE = `${APIRoutes.BASE_URL}/users`;
  public static readonly SINGLE_USER_ROUTE = `${APIRoutes.USERS_ROUTE}/:userId`;
  public static readonly ME_ROUTE = `${APIRoutes.USERS_ROUTE}/me`;
  public static readonly ME_REMOVE_SINGLE_PERMISSIONS_ROUTE = `${APIRoutes.ME_ROUTE}/uop/:uopId`;

  public static readonly ORGS_ROUTE = `${APIRoutes.BASE_URL}/orgs`;
  public static readonly SINGLE_ORG_ROUTE = `${APIRoutes.ORGS_ROUTE}/:orgId`;

  public static readonly PATIENTS_ROUTE = `${APIRoutes.SINGLE_ORG_ROUTE}/patients`;
  public static readonly SINGLE_PATIENT_ROUTE = `${APIRoutes.PATIENTS_ROUTE}/:patientId`;
  public static readonly SKIP_MIGRATION_ROUTE = `${APIRoutes.SINGLE_ORG_ROUTE}/patients/migrate/skip`;
  public static readonly ATTEMPTED_MIGRATION_ROUTE = `${APIRoutes.SINGLE_ORG_ROUTE}/patients/migrate/did-migrate`;

  public static readonly MIGRATE_PATIENTS_ROUTE = `${APIRoutes.SINGLE_ORG_ROUTE}/patients/migrate`;

  public static readonly PATIENT_FORM_ASSIGNMENTS_ROUTE = `${APIRoutes.SINGLE_PATIENT_ROUTE}/form-assignments`;
  public static readonly SINGLE_PATIENT_FORM_ASSIGNMENTS_ROUTE = `${APIRoutes.PATIENT_FORM_ASSIGNMENTS_ROUTE}/:id`;

  public static readonly FORM_ASSIGNMENTS_ROUTE = `${APIRoutes.SINGLE_ORG_ROUTE}/form-assignments`;
  public static readonly SINGLE_FORM_ASSIGNMENTS_ROUTE = `${APIRoutes.FORM_ASSIGNMENTS_ROUTE}/:id`;

  public static readonly ORG_FORMS_ROUTE = `${APIRoutes.SINGLE_ORG_ROUTE}/forms`;
  public static readonly ORG_FORM_BY_IDENTIFIER_ROUTE = `${APIRoutes.ORG_FORMS_ROUTE}/:identifier`;
  public static readonly ORG_FORM_BY_ID_ROUTE = `${APIRoutes.ORG_FORMS_ROUTE}/by-id/:id`;
  public static readonly ORG_FORM_VERSIONS_BY_IDENTIFIER_ROUTE = `${APIRoutes.ORG_FORM_BY_IDENTIFIER_ROUTE}/versions`;
  public static readonly ORG_FORM_VERSION_BY_IDENTIFIER_ROUTE = `${APIRoutes.ORG_FORM_VERSIONS_BY_IDENTIFIER_ROUTE}/:version`;

  public static readonly PATIENT_VISIT_ROUTE = `${APIRoutes.SINGLE_PATIENT_ROUTE}/visits`;
  public static readonly PATIENT_SINGLE_VISIT_ROUTE = `${APIRoutes.PATIENT_VISIT_ROUTE}/:visitId`;

  public static readonly ORG_PERMISSIONS_ROUTE = `${APIRoutes.SINGLE_ORG_ROUTE}/uop`;
  public static readonly SINGLE_ORG_PERMISSIONS_ROUTE = `${APIRoutes.ORG_PERMISSIONS_ROUTE}/:uopId`;

  public static readonly ORG_USERS_ROUTE = `${APIRoutes.SINGLE_ORG_ROUTE}/users`;
  public static readonly SINGLE_ORG_USERS_ROUTE = `${APIRoutes.ORG_USERS_ROUTE}/:userId`;

  public static readonly ORG_INVITES_ROUTE = `${APIRoutes.ORGS_ROUTE}/:orgId/invites`;
  public static readonly SINGLE_ORG_INVITE_ROUTE = `${APIRoutes.ORG_INVITES_ROUTE}/:inviteId`;
  public static readonly RESEND_ORG_INVITE_ROUTE = `${APIRoutes.SINGLE_ORG_INVITE_ROUTE}/resend`;

  public static readonly INVITE_VERIFY_ROUTE = `${APIRoutes.BASE_URL}/invite/verify/:token`;
  public static readonly INVITE_ACCEPT_ROUTE = `${APIRoutes.BASE_URL}/invite/accept/:token`;

  public static readonly ORG_SURVEY_IMAGES_ROUTE = `${APIRoutes.SINGLE_ORG_ROUTE}/survey-images`;
  public static readonly ORG_SURVEY_IMAGES_UPLOAD_ROUTE = `${APIRoutes.ORG_SURVEY_IMAGES_ROUTE}/upload`;

  public static readonly FORM_FILL_CHECK_ROUTE = `${APIRoutes.BASE_URL}/form-fill/check-status/:assignmentId?token=:token`;
  public static readonly FORM_FILL_GET_FORM = `${APIRoutes.BASE_URL}/form-fill/get-form/:assignmentId?token=:token`;
  public static readonly FORM_FILL_SUBMIT_FORM = `${APIRoutes.BASE_URL}/form-fill/submit/:assignmentId?token=:token`;
  public static readonly FORM_FILL_UPLOAD_FILE = `${APIRoutes.BASE_URL}/form-fill/upload-file/:assignmentId?token=:token`;

  public static readonly CALCULATE_PREMO_ROUTE = `${APIRoutes.SINGLE_PATIENT_ROUTE}/calculate-premo`;

  public static readonly PATIENT_TREATMENTS_ROUTE = `${APIRoutes.SINGLE_PATIENT_ROUTE}/treatments`;
  public static readonly PATIENT_SINGLE_TREATMENT_ROUTE = `${APIRoutes.SINGLE_PATIENT_ROUTE}/treatments/:treatmentId`;
  public static readonly TREATMENT_METHOD_ROUTE = `${APIRoutes.BASE_URL}/treatment-methods`;
}
